import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';

import fr from './module-fr.js';
import en from './module-en.js';
import es from './module-es.js';
import de from './module-de.js';
import it from './module-it.js';
import pt from './module-pt.js';
import nl from './module-nl.js';
import pl from './module-pl.js';
import ro from './module-ro.js';
import frBe from './module-fr-BE.js';
import frCh from './module-fr-CH.js';

Vue.use(VueI18n);

const DEFAULT_LANGUAGE = 'fr';

const i18n = new VueI18n({
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: DEFAULT_LANGUAGE,
  silentTranslationWarn: true,
  messages: { fr, en, es, de, it, pt, nl, pl, ro, 'fr-BE': frBe, 'fr-CH': frCh },
});

export default i18n;

const ACCEPTED_LANGUAGES = ['fr', 'en', 'es', 'de', 'it', 'pt', 'nl', 'pl', 'ro', 'fr-BE', 'fr-CH'];

function setI18nLanguage(lang) {
  i18n.locale = lang;
  axios.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);

  return lang;
}

export function loadLanguage(lang) {
  if (!ACCEPTED_LANGUAGES.includes(lang)) {
    throw new Error(`lang ${lang} is not handled`);
  }

  return Promise.resolve(setI18nLanguage(lang));
}
